// extracted by mini-css-extract-plugin
export var button = "commonButton-module--button--5e8b1";